(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

const matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;
export const escapeStringRegexp = string => {
  if (typeof string !== "string") {
    throw new TypeError("Expected a string");
  }

  return string.replace(matchOperatorsRegex, "\\$&");
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(matchOperatorsRegex, "matchOperatorsRegex", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/regexp.js");
  reactHotLoader.register(escapeStringRegexp, "escapeStringRegexp", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/regexp.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();